<mat-card>
  <mat-card-title>
    <p8-layout-settings-header [titlePath]="titlePath()"></p8-layout-settings-header>
  </mat-card-title>
  <mat-card-content>
    <mat-expansion-panel expanded="false">
      <mat-expansion-panel-header>
        <mat-panel-title>
          Texte de la demande d'avis envoyé
        </mat-panel-title>
      </mat-expansion-panel-header>
      <span [innerHTML]="textMessageSent()"></span>
    </mat-expansion-panel>
    <app-data-table
      [dataSource]="dsHistoricAvis"
      [filterDisplay]="false"
      [refreshButton]="false"
      [refreshIcone]="false"
      [extraParams]="extraParams"
      [flexAction]="5" [flexColumn]="90"
      [pageSize]="5" [pageSizesList]="[5,10,25]"
      [columns]="columns"
      [actions]="actions"
      [showFirstLastButtons]="true"
      [fontSizeCell]="'0.9em'"
      [showLoader]="false">
    </app-data-table>
  </mat-card-content>
</mat-card>
